import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    question: 'How is Caveo different from antivirus software?',
    answer: 'Traditional antivirus is reactive — it monitors for threats after they appear. Caveo is proactive and education-first. We teach your family to recognize and avoid threats before they happen, building lasting digital literacy instead of dependency on tools.'
  }, {
    question: 'Do I need to be tech-savvy to use Caveo?',
    answer: 'Not at all! Caveo is designed for every skill level. Our bite-sized lessons use plain language and visual guides that show you exactly what to do. If you can use a smartphone, you can use Caveo.'
  }, {
    question: "What if my family members aren't technical at all?",
    answer: "That's exactly who Caveo is built for. Every guide is written in plain English, with no assumed knowledge. If someone can read a text message, they can follow a Caveo guide."
  }, {
    question: 'How long does the Family Safety Checkup take?',
    answer: "The initial assessment takes under 3 minutes. You'll answer simple questions about your devices and habits, and we'll create a personalized protection plan for your family."
  }, {
    question: 'Can Caveo help if someone in my family has already been scammed?',
    answer: 'Yes. We have a free "I\'ve Been Scammed/Hacked" resource with step-by-step recovery instructions, credit freeze guides, and information on who to contact first. After recovery, our lessons will help prevent it from happening again.'
  }, {
    question: 'What devices and platforms does Caveo support?',
    answer: 'Caveo works across Apple, Android, Windows, and more. Unlike platform-locked solutions, our guidance applies to whatever technology your family actually uses.'
  }];
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-168">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-169">
        <div className="max-w-3xl mx-auto" data-id="element-170">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-4" data-id="element-171">
            Frequently Asked Questions
          </h2>
          <p className="text-base md:text-lg text-gray-500 leading-relaxed mb-12" data-id="element-172">
            Everything you need to know about Caveo
          </p>
          <div className="space-y-4" data-id="element-173">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden" data-id="element-174">
                <div className="flex justify-between items-center cursor-pointer p-6" onClick={() => toggleFaq(index)} data-id="element-175">
                  <h3 className="text-lg font-semibold text-[#111111] pr-4" data-id="element-176">
                    {faq.question}
                  </h3>
                  {openIndex === index ? <MinusIcon className="w-5 h-5 text-[#631bb7] flex-shrink-0" data-id="element-177" /> : <PlusIcon className="w-5 h-5 text-[#631bb7] flex-shrink-0" data-id="element-178" />}
                </div>
                {openIndex === index && <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-179">
                    {faq.answer}
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}